<!-- Modals -->
<app-deprecated-modal-form
    #goalDetailsModal
    [form]="goalDetailsForm"
    (save)="onSave(goalDetailsForm)"
    (cancel)="onCancel()"
    headerText="performance.goal-show.goalDetailsModal.headerText"
>
    <app-form-goal #goalDetailsForm [goal]="goal"></app-form-goal>
</app-deprecated-modal-form>

<app-deprecated-modal-form
    #goalUpdateModal
    [form]="goalUpdateForm"
    (save)="onUpdateSave()"
    (cancel)="onCancel()"
    headerText="performance.goal-show.goalUpdateModal.headerText"
>
    <app-form-goal-update #goalUpdateForm [goal]="goal" [update]="update"></app-form-goal-update>
</app-deprecated-modal-form>

<app-deprecated-confirmation-dialog
    #confirmDelete
    title="performance.goal-show.goalDeleteModal.title"
    description="performance.goal-show.goalDeleteModal.description"
    label="performance.goal-show.goalDeleteModal.deleteLabel"
    [negative]="true"
>
</app-deprecated-confirmation-dialog>

<app-deprecated-confirmation-dialog
    #confirmUpdateDelete
    title="performance.goal-show.goalProgressDeleteModal.title"
    description="performance.goal-show.goalProgressDeleteModal.description"
    label="performance.goal-show.goalProgressDeleteModal.deleteLabel"
    [negative]="true"
>
</app-deprecated-confirmation-dialog>

<app-deprecated-confirmation-dialog
    #confirmComplete
    title="performance.goal-show.goalCompletionModal.title"
    description="performance.goal-show.goalCompletionModal.description"
    label="performance.goal-show.goalCompletionModal.completeLabel"
    [negative]="false"
>
</app-deprecated-confirmation-dialog>

<app-deprecated-confirmation-dialog
    #confirmMissed
    title="performance.goal-show.goalMissedModal.title"
    description="performance.goal-show.goalMissedModal.description"
    label="performance.goal-show.goalMissedModal.missedLabel"
    [negative]="true"
>
</app-deprecated-confirmation-dialog>

<app-common-bulk-select-employee-dialog
    #appEmployeeSelection
    label="performance.goal-show.assignEmployeeLabel"
></app-common-bulk-select-employee-dialog>

<!-- Body -->
<div class="ui basic narrow segment" [class.loading]="isLoading">
    <app-header
        [title]="goal.title"
        [back]="true"
        [contextMenu]="canAdministrate || isCreator"
        contextMenuType="material"
    >
        <button mat-menu-item *ngIf="goal.statusId !== Status.Completed" (click)="goalDetailsModal.show()">
            {{ 'performance.goal-show.editLabel' | translate }}
        </button>
        <button
            mat-menu-item
            *ngIf="
                goal.statusId !== Status.Overdue &&
                goal.statusId !== Status.Missed &&
                goal.statusId !== Status.Completed
            "
            (click)="onForceComplete()"
        >
            {{ 'performance.goal-show.markAsCompleted' | translate }}
        </button>
        <button mat-menu-item *ngIf="goal.statusId === Status.Overdue" (click)="onForceMissed()">
            {{ 'performance.goal-show.markAsMissed' | translate }}
        </button>
        <button mat-menu-item (click)="onDelete()">{{ 'performance.goal-show.delete' | translate }}</button>
    </app-header>

    <div class="ui segment">
        <div class="due_at">
            <i class="fal fa-clock"></i>&nbsp;&nbsp;<strong>{{ 'performance.goal-show.dueAt' | translate }}</strong>
            {{ goal.dueAt | appDate: 'mediumDate' }}
        </div>
        <div class="goalStatus">
            <ng-container *ngIf="goal.statusId === Status.Completed">
                <span class="ui tiny circular empty green label"></span>
                {{ 'performance.goalStatuses.completed' | translate }}
            </ng-container>
            <ng-container *ngIf="goal.statusId === Status.InProgress">
                <span class="ui tiny circular empty yellow label"></span>
                {{ 'performance.goalStatuses.inProgress' | translate }}
            </ng-container>
            <ng-container *ngIf="goal.statusId === Status.Missed">
                <span class="ui tiny circular empty orange label"></span>
                {{ 'performance.goalStatuses.missed' | translate }}
            </ng-container>
            <ng-container *ngIf="goal.statusId === Status.Overdue">
                <span class="ui tiny circular empty red label"></span>
                {{ 'performance.goalStatuses.overdue' | translate }}
            </ng-container>
        </div>
        <div class="clear" style="margin-bottom: 25px"></div>

        <div class="goalProgress">
            <!-- Shared Goal (single goal), Communal Progress -->
            <ng-template [ngIf]="goal.isShared">
                <p class="left floated">
                    <strong>{{ 'performance.goal-show.current' | translate }}</strong> {{ goal?.currentValue }}
                </p>
                <p class="right floated">
                    <strong>{{ 'performance.goal-show.sharedGoal' | translate }}</strong> {{ goal?.metricValue }}
                </p>
                <div class="ui blue thin clear progress shared">
                    <div class="bar"></div>
                </div>
                <div class="percent">{{ sharedPercent }}%</div>
            </ng-template>

            <!-- Not Shared (individual goals), Not Active User -->
            <ng-template [ngIf]="!goal.isShared && !goal.userIsParticipant">
                <p class="left floated">
                    <strong>{{ 'performance.goal-show.current' | translate }}</strong> {{ goal?.currentValue }}
                </p>
                <p class="right floated">
                    <strong>{{ 'performance.goal-show.sharedGoal' | translate }}</strong> {{ goal?.sharedMetricValue }}
                </p>
                <div class="ui blue thin clear progress shared">
                    <div class="bar"></div>
                </div>
                <div class="percent">{{ sharedPercent }}%</div>
            </ng-template>

            <!-- Not Shared (individual goals), Is Active User -->
            <ng-template [ngIf]="!goal.isShared && goal.userIsParticipant">
                <p class="left floated">
                    <strong>{{ 'performance.goal-show.everyone' | translate }}</strong> {{ goal?.currentValue }}
                </p>
                <p class="right floated">
                    <strong>{{ 'performance.goal-show.sharedGoal' | translate }}</strong> {{ goal?.sharedMetricValue }}
                </p>
                <div class="ui blue thin clear progress shared">
                    <div class="bar"></div>
                </div>
                <div class="percent">{{ sharedPercent }}%</div>
                <div class="clear"></div>
                <p class="left floated">
                    <strong> {{ auth.employee?.fullName }}: </strong>
                    {{ individualProgress?.currentValue }}
                </p>
                <p class="right floated">
                    <strong>{{ 'performance.goal-show.individualGoal' | translate }}</strong>
                    {{ goal?.metricValue || 0 }}
                </p>
                <div class="ui blue thin clear progress individual">
                    <div class="bar"></div>
                </div>
                <div class="percent">{{ individualPercent }}%</div>
            </ng-template>
            <div class="clear"></div>

            <ng-template [ngIf]="goal.metricType === 'milestones' && goal.metricMilestones">
                <div class="ui two column grid milestones">
                    <div *ngFor="let milestone of goal.metricMilestones; let index = index" class="milestone column">
                        <i
                            *ngIf="goal?.currentMilestones && (goal?.currentMilestones)[index]?.complete"
                            class="ui fal fa-check-square"
                        ></i>
                        <i
                            *ngIf="!goal?.currentMilestones || !(goal?.currentMilestones)[index]?.complete"
                            class="ui fal fa-square"
                        ></i>
                        <span class="header">{{ milestone.label }}</span> -
                        <span class="description">{{ milestone.description }}</span>
                    </div>
                </div>
            </ng-template>
        </div>
        <p style="max-width: 60%">{{ goal.description }}</p>
    </div>

    <div class="ui segment">
        <div class="ui hidden divider"></div>
        <ng-template [ngIf]="goal.userIsParticipant">
            <ui-button type="link" style="float: right" (click)="goalUpdateModal.show()">{{
                'performance.goal-show.update' | translate
            }}</ui-button>
        </ng-template>
        <app-segment-header title="performance.goal-show.timelineTitle"></app-segment-header>

        <p *ngIf="!goal.updates?.length">{{ 'performance.goal-show.noUpdatesToGoal' | translate }}</p>
        <div *ngIf="goal.updates" class="ui comments">
            <div
                *ngFor="let update of goal.updates"
                class="comment"
                [class.positive]="update.onTrack"
                [class.negative]="update.offTrack"
            >
                <a class="avatar">
                    <app-avatar *ngIf="update.employee" [employee]="update.employee"></app-avatar>
                </a>
                <div class="content">
                    <a class="author">{{ update.employee?.firstName }} {{ update.employee?.lastName }}</a>
                    <div class="metadata">
                        <span class="date">{{ update.createdAt }}</span>
                        <i style="cursor: pointer" (click)="onDeleteUpdate(update)" class="fal fa-trash"></i>
                    </div>
                    <div class="text">{{ update.comment }}</div>
                    <div
                        *ngIf="update.metricIncrement && update.metricValue && !update.metricMilestones"
                        class="actions"
                        [innerHTML]="
                            'performance.goal-show.metricIncrementMsg'
                                | translate: { updatedMetricValue: update.metricValue, metricValue: goal.metricValue }
                                | sanitizeHtml
                        "
                    ></div>
                    <div
                        *ngIf="update.metricTotal && update.metricValue !== null && !update.metricMilestones"
                        class="actions"
                        [innerHTML]="
                            'performance.goal-show.metricTotalIncrementMsg'
                                | translate: { updatedMetricValue: update.metricValue, metricValue: goal.metricValue }
                        "
                    ></div>
                    <div *ngIf="update.metricMilestones" class="actions">
                        <strong>{{ 'performance.goal-show.updatedMilestones' | translate }}</strong>
                    </div>
                </div>
                <div class="clear"></div>
            </div>
        </div>
    </div>
    <div class="ui hidden divider"></div>

    <div class="ui table segment">
        <app-segment-header title="performance.goal-show.participantsTitle" (edit)="onAssign()"></app-segment-header>

        <table *ngIf="goal.assignments && goal.assignments.length" class="ui unstackable table">
            <tbody>
                <tr *ngFor="let assignment of goal.assignments">
                    <td class="collapsing">
                        <app-avatar *ngIf="assignment.employee" [employee]="assignment.employee"></app-avatar>
                    </td>
                    <td>{{ assignment?.employee?.firstName }} {{ assignment?.employee?.lastName }}</td>
                    <td class="right aligned">
                        <ng-container *ngIf="assignment.isComplete">
                            <span class="ui tiny circular empty green label"></span>
                            {{ 'performance.goalStatuses.completed' | translate }}
                        </ng-container>
                        <ng-container *ngIf="!assignment.isComplete">
                            <span class="ui tiny circular empty yellow label"></span>
                            {{ 'performance.goalStatuses.inProgress' | translate }}
                        </ng-container>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <div class="ui table segment">
        <app-segment-header title="performance.goal-show.createdByTitle"></app-segment-header>
        <table *ngIf="goal.creator" class="ui unstackable table">
            <tbody>
                <tr>
                    <td class="collapsing">
                        <app-avatar *ngIf="goal.creator" [employee]="goal.creator"></app-avatar>
                    </td>
                    <td>{{ goal?.creator?.firstName }} {{ goal?.creator?.lastName }}</td>
                </tr>
            </tbody>
        </table>
    </div>

    <div class="ui hidden divider"></div>
</div>
